import * as vp from 'vopay';
import React, { useMemo } from 'react';
import styles from './App.module.scss';

import { useConfirmationDialogue } from './providers/ConfirmationDialogue.provider';
import useDataFetchIndicator from './hooks/useDataFetchIndicator';
import Layout from './pages/Layout';
import useActivePage from './hooks/useActivePage';

const { ConfirmationDialogue, LoadingIndicator } = vp;

const App = (): React.JSX.Element => {
  const dialogueProps = useConfirmationDialogue();
  const [[isFetchingData, loadingMessage, indicator]] = useDataFetchIndicator();
  const { activePage } = useActivePage();

  return (
    <div className={styles.app}>
      {useMemo(
        () => (
          <ConfirmationDialogue {...dialogueProps} />
        ),
        [dialogueProps],
      )}
      {useMemo(
        () => (
          <LoadingIndicator
            isVisible={isFetchingData && (indicator === 'fullScreen' || indicator === undefined)}
            message={loadingMessage}
            noLeadingDots
            hasNoMessage
            hasNoTitle
            size="lg"
          />
        ),
        [isFetchingData],
      )}

      {activePage === 'connect' && <Layout />}
    </div>
  );
};

export default App;
